<template>
	<div :class="`carousel-block carousel-block--${block.content.alignment}`">
		<client-only-wrapper>
			<div class="carousel-wrapper">
				<div class="slick-carousel">
					<VueSlickCarousel
						ref="slick"
						v-bind="slickOptions"
						@afterChange="afterSlideChange"
					>
						<template v-for="(slide, index) in block.content.slides">
							<!-- eslint-disable-next-line -->
							<img
								:key="index"
								class="carousel-image"
								:src="slide.media.url"
								:alt="slide.caption"
							/>
						</template>
					</VueSlickCarousel>
				</div>
				<div class="carousel-captions">
					<template v-for="(slide, index) in block.content.slides">
						<div
							:key="index"
							:class="[
								{
									'is-active': currentSlide === index && slide.caption
								},
								'carousel-caption'
							]"
						>
							<template v-if="slide.caption">
								{{ slide.caption }}
							</template>
						</div>
					</template>
				</div>
				<div>
					<ul class="carousel-nav">
						<li>
							<helio-icon
								class="carousel-arrow"
								token="angle-left"
								weight="bold"
								@click="prevSlide()"
							/>
						</li>
						<li
							v-for="(slide, index) in block.content.slides"
							:key="index"
							:class="{
								'is-active':currentSlide === index
							}"
							@click="goTo(index)"
						>
							<span class="carousel-dots" />
						</li>
						<li>
							<helio-icon
								class="carousel-arrow"
								token="angle-right"
								weight="bold"
								@click="nextSlide()"
							/>
						</li>
					</ul>
				</div>
			</div>
		</client-only-wrapper>
	</div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import Icon from '../../../icon/Icon.vue';
import ClientOnlyWrapper from '../../../client-only-wrapper/ClientOnlyWrapper.vue';

export default {
	components: {
		'helio-icon': Icon,
		VueSlickCarousel,
		ClientOnlyWrapper,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		next: {
			type: Object,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			slickOptions: {
				adaptiveHeight: false,
				arrows: false,
				centerMode: true,
				dots: false,
				infinite: true,
				slidesToShow: 1,
				responsive:
				[
					{
						breakpoint: 480,
						settings: {
							centerMode: false,
						},
					},
				],
			},
			currentSlide: 0,
		};
	},
	methods: {
		nextSlide() {
			this.$refs.slick.next();
		},
		prevSlide() {
			this.$refs.slick.prev();
		},
		goTo(slide) {
			this.$refs.slick.goTo(slide);
		},
		afterSlideChange(slideIndex) {
			this.currentSlide = slideIndex;
		},
	},
};
</script>

<style lang="scss" src="./carousel-block.scss" />
